import { type LoaderFunctionArgs, redirect } from "@remix-run/node";
import { Outlet } from "@remix-run/react";
import { ROUTES } from "~/consts";
import { getSession } from "~/session.server";

export async function loader({ request }: LoaderFunctionArgs) {
	const session = await getSession(request);
	if (session.has("accessToken")) return redirect(ROUTES.root);

	return null;
}

export default function UserLayout() {
	return <Outlet />;
}
